module.exports = __webpack_public_path__ + "img/qxc_bg.f503314c.png";